var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00279 8.67843C6.11102 8.67843 7.17385 8.23819 7.95749 7.45456C8.74112 6.67092 9.18136 5.60809 9.18136 4.49986C9.18136 3.39163 8.74112 2.3288 7.95749 1.54516C7.17385 0.76153 6.11102 0.321289 5.00279 0.321289C3.89456 0.321289 2.83173 0.76153 2.04809 1.54516C1.26446 2.3288 0.824219 3.39163 0.824219 4.49986C0.824219 5.60809 1.26446 6.67092 2.04809 7.45456C2.83173 8.23819 3.89456 8.67843 5.00279 8.67843Z",
    stroke: "#707070",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03906 6.42871H5.96763",
    stroke: "#707070",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00223 6.42871V4.17871H4.35938",
    stroke: "#707070",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00251 2.73158C4.95989 2.73158 4.91901 2.71465 4.88887 2.68451C4.85873 2.65437 4.8418 2.61349 4.8418 2.57087C4.8418 2.52825 4.85873 2.48737 4.88887 2.45723C4.91901 2.42709 4.95989 2.41016 5.00251 2.41016",
    stroke: "#707070",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00195 2.73158C5.04458 2.73158 5.08546 2.71465 5.1156 2.68451C5.14574 2.65437 5.16267 2.61349 5.16267 2.57087C5.16267 2.52825 5.14574 2.48737 5.1156 2.45723C5.08546 2.42709 5.04458 2.41016 5.00195 2.41016",
    stroke: "#707070",
    strokeWidth: 0.642857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.6cac81255c7ecff2d0bec6482d751002.svg";
export { ForwardRef as ReactComponent };